import { Injectable } from '@angular/core';
var MapsAPILoader = /** @class */ (function () {
    function MapsAPILoader() {
    }
    MapsAPILoader.decorators = [
        { type: Injectable },
    ];
    return MapsAPILoader;
}());
export { MapsAPILoader };
//# sourceMappingURL=maps-api-loader.js.map


// WEBPACK FOOTER //
// ./node_modules/@agm/core/services/maps-api-loader/maps-api-loader.js.pre-build-optimizer.js